export function scrumbleDataToSave<T>(data: any): string {
  const toScrumble = ['6d3.', '4d', '2s=', '24g', '1', '4d', '54dv', '6y', '857h=', '38ui=.'];

  const json = JSON.stringify(data);
  const randomNumber = Math.floor(Math.random() * 10);
  // Se agrega un numero al comienzo y un par de letras al final
  const firstEncrypt = randomNumber + btoa(json) + toScrumble[randomNumber];

  return btoa(firstEncrypt);
}

export function parseSavedData<T>(data, defaultV: T): T {
  const toScrumble = ['6d3.', '4d', '2s=', '24g', '1', '4d', '54dv', '6y', '857h=', '38ui=.'];

  try {
    const firstDecrypt = atob(data);
    const numberD = firstDecrypt[0];

    if (isNaN(parseInt(numberD, 10))) { return defaultV; }

    const cleaned = firstDecrypt.slice(1, firstDecrypt.length - toScrumble[numberD].length);

    return JSON.parse(atob(cleaned));
  } catch (e) {
    return defaultV;
  }
}
